<template>
  <div class="sign-in" v-if="userData">
    <el-tooltip placement="bottom-start" effect="light">
      <div slot="content" class="leader-user-info">
        <div class="user-info">
          <div class="user-img">
            <img :src="userData.avatar" alt="" />
          </div>
          <h2 class="name">{{ userData.name }}</h2>
          <p>{{ userData.mobile }}</p>
          <p>{{ userData.telephone }}</p>
          <p>{{ userData.email }}</p>
          <div style="clear: both">
            <p>{{ userData.department }}</p>
            <p v-if="userData.position">职务：{{ userData.position }}</p>
          </div>
        </div>
      </div>
      <!-- 
        <div class="leader-user-title">
          <i class="iconfont icon-user leader-user-icon"></i>
          {{ userData.name+" - "+(userData.childDept?userData.childDept:userData.position)) }}
        </div> 
      -->
      <div class="leader-user-title">
        <i class="iconfont icon-user leader-user-icon"></i>{{ userData.name }}
      </div>
    </el-tooltip>
  </div>
</template>

<script>
export default {
  name: "UserInfo",
  props: ["userData"],
  data() {
    return {};
  },
  mounted() {},
  methods: {},
};
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/UserInfo.vue